import { useState } from "react";
import { Button, Checkbox, EmptyState, PageHead, Panel, Skeleton } from "@guestpilot/ui-kit";
import { useWrite } from "../api/hooks";
import { InboxList } from "../components/InboxList";
import { useHandleApiError } from "../errors";
import { useI18n } from "../i18n";
import { useInbox } from "../lib/inbox";

/** The caller's notices, newest first (BR-075, BR-219, D-148). */
export function Notifications() {
  const { t } = useI18n();
  const fail = useHandleApiError();
  const [unreadOnly, setUnreadOnly] = useState(false);
  const q = useInbox(100, unreadOnly);
  const readAll = useWrite("POST", "/api/v1/inbox/read-all", ["/api/v1/inbox"]);
  const items = q.data?.items ?? [];
  return (
    <div className="gp-page">
      <PageHead
        title={t("ui:inbox.title")}
        subtitle={t("ui:inbox.subtitle")}
        actions={
          <Button
            disabledReason={(q.data?.unread ?? 0) === 0 ? t("ui:inbox.emptyUnread") : undefined}
            onClick={() => readAll.mutate(undefined, { onError: fail })}
          >
            {t("ui:inbox.markAllRead")}
          </Button>
        }
      />
      <Checkbox checked={unreadOnly} onChange={setUnreadOnly} label={t("ui:inbox.unreadOnly")} />
      <Panel label={t("ui:inbox.title")}>
        {q.isLoading ? (
          <Skeleton rows={4} />
        ) : items.length === 0 ? (
          <EmptyState title={unreadOnly ? t("ui:inbox.emptyUnread") : t("ui:inbox.empty")} />
        ) : (
          <InboxList items={items} />
        )}
      </Panel>
    </div>
  );
}
